var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"component-header"},[_c('div',{staticClass:"component-header__title"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }